<template>
  <header>
    <slot></slot>
    <div class="text">
      <h1>Абхазия — страна души</h1>
      <p>Абхазия – это теплое море, ласковое солнце, субтропический лес, бурные горные реки, многочисленные водопады,
        таинственные пещеры, прибрежные скалы и захватывающие дух виды на горы Кавказа. На протяжении столетий Абхазия
        привлекает множество туристов.</p>
    </div>
    <a href="#to" class="down">
      <img src="/img/arrow-down.png" alt />
    </a>
  </header>
</template>

<style scoped>
header {
  height: calc(100vh + 1px);
  /* max-height: calc(100vh + 1px); */
  background-image: url("/img/header_about_plash.png");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: flex-start;
  align-content: space-between;
  padding-top: 30px;
  position: relative;
}

header .text {
  position: absolute;
  bottom: 106px;
  right: 50%;
  left: 75px;
}

header .text h1 {
  font-family: "playfair";
  font-size: 69px;
  line-height: 57px;
  color: white;
}

header .text p {
  color: white;
  width: 100%;
  margin: 0px;
  font-family: "Lato";
  font-size: 20px;
  line-height: 24px;
}

.down {
  position: absolute;
  bottom: 25px;
  left: calc(50% - 37.175px);
}

@media screen and (max-width: 1200px) {
  header[data-v-2b09b888] {
    height: 780px;
    /* max-height: calc(80vh + 1px); */
  }

  header .text {
    position: relative !important;
    bottom: 0px;
    right: 0px;
    left: 0px;
    text-align: center;
    top: 0px;
    margin: auto;
  }

  header .text h1 {
    font-size: 38px;
  }

  header .text p {
    font-size: 16px;
  }
}
</style>

<style>
html {
  scroll-behavior: smooth;
}
</style>